import { Grid, Typography, useTheme } from '@mui/material';
import * as React from 'react';
import DateFilter from 'src/components/DateFilter';

import QueryValuesLayout from 'src/components/Layouts/QueryValuesLayout';
import DashboardPageLayout from 'src/frontend-common/components/DashboardPageLayout';

import LoadingScreen from 'src/frontend-common/components/LoadingScreen';
import { useFrontendAnalytics } from 'src/hooks/useFrontendAnalytics';

const AdminDashboardWrapper: React.FC = () => {
  const FrontendAnalytics = useFrontendAnalytics();
  const theme = useTheme();
  return (
    <QueryValuesLayout excludeValues={['dateRange', 'token', 'tab']}>
      {({ dateRange, setDateRange }) => (
        <DashboardPageLayout>
          <Grid
            container
            justifyContent="space-between"
            style={{
              padding: theme.spacing(3, 0),
            }}
          >
            <Grid item xs={12} md={6}>
              <Typography variant="h2">Admin Dashboard</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <DateFilter
                dateRange={dateRange}
                setDateRange={(range) => {
                  setDateRange(range);
                }}
              />
            </Grid>
          </Grid>
          <React.Suspense fallback={<LoadingScreen variant="circle" />}>
            <FrontendAnalytics product="Admin Dashboard" analyticsFilters={{ start_date: dateRange.startDate, end_date: dateRange.endDate }} />
          </React.Suspense>
        </DashboardPageLayout>
      )}
    </QueryValuesLayout>
  );
};

export default AdminDashboardWrapper;
